// Розділ Rozetka: ціни з комісією категорії, залишки лише зі складу Rozetka
export const ROZETKA_WAREHOUSE_ID = 3;

// Опції магазинів
export const WAREHOUSE_OPTIONS = [
  { id: 0, name: "Онлайн магазин" },
  { id: 1, name: "Уцінка" },
  { id: 2, name: "Магазин ОККО" },
  { id: ROZETKA_WAREHOUSE_ID, name: "Rozetka" },
];
